export const AVA_MAINNET = {
  DEGIS: "",
  POLICYFLOW: "",
  INSURANCEPOOL: "",
};

export const FUJI = {
  DEGIS: "0x0f799713D3C34f1Cbf8E1530c53e58a59D9F6872",
  MOCKUSD: "0xF886dDc935E8DA5Da26f58f5D266EFdfDA1AD260",
  BUYERTOKEN: "0x0944729C5125576a7DB450F7F730dC5A2a1E1359",
  FD_POLICYTOKEN: "0x9B1Cda0861ACD7E28dc7bEDA874eB7aB42b0016B",
  POLICYFLOW: "0xfAa5961cE2090C7cc5602AA7bDA75401bD47fB32",
  INSURANCEPOOL: "0x904C30be1D840334B346E13DA4Cb93f5D8277358",
  DEGISLOTTERY: "0xd7E79CabAC56FBc772B022badD832b3979C9f7fE",
  NAUGHTYFACTORY: "0x5655dDf58776A7F3722c592b524558de55Cf2DAB",
  NAUGHTYROUTER: "0x3A5Ec4E77f1779901FA91dCD9e5Ad2418415f77e",
  POLICYCORE: "0x556b49D67D0A02aAB02A61004Aad2E9D363f1Ebd",
  FARMINGPOOL: "0x7C824EC3eff695ffbBBb44410144fDeB00862A69",
  PURCHASEINCENTIVEVAULT: "0xdaDBED62C861F036f9214D75491216557d806d0F",
};

export const RINKEBY = {
  DEGIS: "0x6d3036117de5855e1ecd338838FF9e275009eAc2",
  MOCKUSD: "0xAc141573202C0c07DFE432EAa1be24a9cC97d358",
  BUYERTOKEN: "0x876431DAE3c10273F7B58567419eb40157CcA9Eb",
  FD_POLICYTOKEN: "0x7D3D5d8c83Bc877c56F00fa8D65bfB7F972c7E3F",
  POLICYFLOW: "0x19145b0AcFC8F38F59822Be268Ee636A5C055281",
  INSURANCEPOOL: "0x357c3a5B8Ec188852E52c4e63798a58359515E84",
  DEGISLOTTERY: "0xa85D352ED54952E2C4e147B43A7D461bb395CbeE",
  NAUGHTYFACTORY: "0x0821Acb08089716E6fd7610D9603897FEA6177b6",
  NAUGHTYROUTER: "0xDc5f05ff3188570207f054B9751ba87Cb1488CcD",
  POLICYCORE: "0x133AE7F34D38077A8b0EC6d3e0bF810bcDde131e",
  FARMINGPOOL: "0xC3E497a38C62B66620e21F9E7Ca2180d8Cd6716B",
  PURCHASEINCENTIVEVAULT: "0x2774836A4549aEcc01654be8D98D62440B4E64C1",
};


